export const BUILD_VERSION = {
  "buildNumber": 126,
  "buildDate": "2026_07_07",
  "version": "00126/2026_07_07",
  "releaseVersion": "v1.0.20"
};